import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieConsentService } from '../services/cookie-consent.service';

@Injectable()
export class CookieInterceptor implements HttpInterceptor {
  
  constructor(private cookieConsentService: CookieConsentService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Se os cookies foram rejeitados, remove withCredentials das requisições
    if (!this.cookieConsentService.areCookiesEnabled()) {
      // Remove withCredentials se estiver presente
      if (request.withCredentials) {
        request = request.clone({
          withCredentials: false
        });
      }
    }
    
    return next.handle(request);
  }
} 